<ng-container *ngIf="isFaIcon; else notFaIcon">
  <fa-icon [icon]="faIcons[icon]" [attr.data-testid]="'fa-icon'"></fa-icon>
</ng-container>

<ng-template #notFaIcon>
  <ng-container *ngIf="isSvgFile; else notSvgFile">
    <div
      class="inline-svg"
      [inlineSVG]="icon"
      [attr.data-testid]="'svg-icon'"
    ></div>
  </ng-container>
</ng-template>

<ng-template #notSvgFile>
  <mat-icon [attr.data-testid]="'material-icon'"> {{ icon }} </mat-icon>
</ng-template>
